import React, { useContext, useEffect, useState } from "react";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import Loader from "../../Helpers/Loader/Loader";
import { popupcontext } from "../../../context/Popupscontext";
import { useGetSpecificPOIQuery } from "../../../Redux/service/POIS/POIs";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import { Segmented } from "antd";
import trans from "../../../utils";
import POIsGeneral from "./POIsGeneral";
import POIsSetupLocation from "./POIsSetupLocation";
import POIsContact from "./POIsContact";
import POIsExtra from "./POIsExtra";

export default function POIsPopup({ poiId }) {
	const {
		data: poidetails,
		isLoading,
		refetch,
	} = useGetSpecificPOIQuery(poiId, { skip: !poiId });
	let { edited, handleClose } = useContext(popupcontext);
	console.log("POIdetails", poidetails);
	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch, poiId]);
	const [type, setType] = useState("General");
	return (
		<Popup show={!!poiId} style={"popup-bodyscroll"}>
			{isLoading && (
				<div className="loader-container">
					<Loader />
				</div>
			)}
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={`${poidetails?.data?.name}`} />
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={() => handleClose("display")}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={[
					{ label: trans("general"), value: "General" },
					{ label: trans("location setup"), value: "LocationSetup" },
					{ label: trans("contact info"), value: "Contactinfo" },
					{ label: trans("extra"), value: "Extra" },
				]}
				block
				onChange={(e) => setType(e)}
				value={type}
			/>
			<Modal.Body className="modal-body-scrollable">
				{type === "General" && <POIsGeneral poidetails={poidetails?.data} />}
				{type === "LocationSetup" && (
					<POIsSetupLocation poidetails={poidetails?.data} />
				)}
				{type === "Contactinfo" && (
					<POIsContact poidetails={poidetails?.data} />
				)}
				{type === "Extra" && <POIsExtra poidetails={poidetails?.data} />}
			</Modal.Body>
		</Popup>
	);
}
